import { EABFilterImplementationType, EisenhowerPriority, type FilterOption } from "@/graphql";
import type { EventFilter } from "../FilterTypes";
import PriorityFilterUI from "../ui/PriorityFilterUI.vue";
import PriorityFilterBadge from "../ui/badges/PriorityFilterBadge.vue";

export default class PriorityFilter implements EventFilter {
  constructor(
    public readonly priorities: EisenhowerPriority[],
    public readonly isNegated?: boolean,
  ) {}

  static readonly Badge = PriorityFilterBadge;

  static readonly UI = PriorityFilterUI;

  getEventFilter(): FilterOption | undefined {
    return {
      filter: {
        type: EABFilterImplementationType.EVENT_EISENHOWER_PRIORITY,
        value: {
          value: this.priorities,
          negated: this.isNegated ?? false,
        },
      },
    };
  }
}
